import { ActivityApiV1DashboardActivityGetTab } from '#/shared/api/generated/audit/models'

export const RECENT_ACTIVITY_SEGMENT_KEYS = ActivityApiV1DashboardActivityGetTab

export type RecentActivitySegmentKey =
  (typeof RECENT_ACTIVITY_SEGMENT_KEYS)[keyof typeof RECENT_ACTIVITY_SEGMENT_KEYS]
